import React from 'react';
import { Cell } from 'react-table';

import { formatDollarsCompact } from '@trqk/utils';

interface PaymentsCellProps {
    cell: Cell<TrqkGapChannel, number>;
}

/**
 * Displays the total payments for a channel in a compact format, like `$1K`, using
 * `formatDollarsCompact`. If the value is 0, nothing is displayed.
 * @param props - {@link EstimatedLossCellProps}
 */
export function PaymentsCell({ cell }: PaymentsCellProps): React.ReactNode {
    const { value } = cell;

    if (value === 0) {
        return null;
    }

    return (
        <div className="flex justify-end pr-2">
            <span>
                {typeof value === 'string'
                    ? value
                    : formatDollarsCompact(value)}
            </span>
        </div>
    );
}
